import Vue from 'vue'
import { storeTypeGetStoreTypeList } from '@/api/crm'

const templateType = {
  ORDER: '客户整本设计',
  COMMON: '本本相同',
  PERSONAL: '本本不同'
}
const barcodePosition = {
  LEFT: '左',
  RIGHT: '右',
  TOP: '上',
  BOTTOM: '下'
}
const pageType = {
  COVER: '封面',
  SINGLE: '单页',
  TEXT: '内页'
}
const spuType = {
  DIY: 'DIY定制',
  NORMAL: '通货',
  SAMPLE: '样品',
  CUSTOM: '定制',
  SALE_SAMPLE: '业务样品'
}
const leftComposeCode = {
  NONE: '不显示',
  MACHINE_CODE: '机器码',
  JOB_CODE: '任务码'
}
const orderStatus = {
  // NEW: '新订单',
  SUBMITTED: '新订单',
  CONFIRMED: '已确认',
  PROCESSING: '制作中',
  // RENDER_WAIT: '等待合成',
  // RENDERING: '合成中',
  RENDER_DONE: '合成完成',
  // RENDER_FAILED: '合成失败',
  DONE_DOWNLOAD: '下载完成',
  SHIPPED: '已发货',
  COMPLETED: '订单完成',
  // REFUNDING: '退款中',
  // REFUNDED: '退款完成',
  CANCELLED: '订单取消',
  AFTERSALESED: '已售后'

}
const originTypes = {
  APP: 'APP',
  MP: '小程序',
  TB: '淘宝'
}
const orderItemStatus = {
  NEW: '新订单',
  RENDER_WAIT: '等待合成',
  RENDERING: '合成中',
  RENDER_FAILED: '合成失败',
  RENDER_DONE: '合成完成',
  SHIPPED: '已发货',
  COMPLETED: '订单完成',
  CANCELLED: '订单取消',
  SIGNED: '已签收',
  AFTERSALESED: '已售后'
}
const orderType = {
  NORMAL: '标准',
  CUSTOM: '定制',
  SAMPLE: '样品'
  // CHARGE: 'CHARGE',
  // OTHER: 'OTHER'
}
// 余额明细 支付方式
const payType = {
  WXPAY: '微信',
  ALIPAY: '支付宝',
  VP_ACCT: '充值余额',
  VP_SETTLE: '结算余额',
  VP_BONUS: '礼金券',
  OFFLINE: '线下支付',
  PROMO: '免单码'

}
const paymentTypeCz = {
  // WXPAY: '微信',
  // ALIPAY: '支付宝',
  // // BONUS: '虚拟充值',
  // VPAY: '余额'
  // // OFFLINE: '线下支付',
  // // UNIONPAY: '银联'

  UNIONPAY: '银联扫码支付',
  // OTHER: 'OTHER',
  VP_BONUS: '礼金券',
  VP_SETTLE: '结算余额支付',
  PROMO: '免单码',
  // QQPAY: '手机QQ支付',
  WXPAY: '微信',
  ALIPAY: '支付宝',
  VP_ACCT: '充值余额支付',
  OFFLINE: '线下支付'
  // CMBCHINA: '招商-聚合支付'
}
const paymentType = {
  // WXPAY: '微信',
  // ALIPAY: '支付宝',
  // // BONUS: '虚拟充值',
  // VPAY: '余额'
  // // OFFLINE: '线下支付',
  // // UNIONPAY: '银联'
  UNIONPAY: '银联扫码支付',
  // OTHER: 'OTHER',
  VP_BONUS: '礼金券',
  VP_SETTLE: '结算余额支付',
  PROMO: '免单码',
  // QQPAY: '手机QQ支付',
  WXPAY: '微信',
  ALIPAY: '支付宝',
  VP_ACCT: '充值余额支付'
  // OFFLINE: '线下支付'
  // CMBCHINA: '招商-聚合支付'
}
const paymentTypeB = {
  // WXPAY: '微信',
  // ALIPAY: '支付宝',
  // // BONUS: '虚拟充值',
  // VPAY: '余额'
  // // OFFLINE: '线下支付',
  // // UNIONPAY: '银联'

  UNIONPAY: '银联扫码支付',
  // OTHER: 'OTHER',
  VP_BONUS: '礼金券',
  VP_SETTLE: '结算余额支付',
  // PROMO: '免单码',
  // QQPAY: '手机QQ支付',
  WXPAY: '微信',
  ALIPAY: '支付宝',
  VP_ACCT: '充值余额支付',
  // OFFLINE: '线下支付'
  // CMBCHINA: '招商-聚合支付'
  BRIDAL_STORE_POINT: '积分支付'

}
const paymentTypes = {
  VP_ACCT: '充值余额',
  VP_SETTLE: '结算余额',
  VP_BONUS: '礼金券'
}

// 支付状态
const paymentStatus = {
  UNPAID: '未支付',
  PAID: '已支付'
}
const tradeType = {
  // CANCEL: 'CANCEL',
  CHARGE: '充值',
  TRADE: '消费',
  REFUND: '退款',
  DEDUCT: '扣款'
}

// 充值方式
const tradeMethod = {
  CHARGE_OFFLINE_TRANSFER_IN: '余额转入',
  TRADE_ORDER_POSTSALE: '售后扣款',
  CHARGE_OTHER: '余额其它',
  CHARGE_QRCODE: '线上充值',
  CHARGE_OFFLINE: '线下充值',
  CHARGE_OFFLINE_SETTLE: '结算',
  // CHARGE_OFFLINE_SETTLE: '结算充值',
  TRADE_ORDER_FEE: '扣运费',
  TRADE_PROMO: '优惠码支付',
  REFUND_PROMO: '优惠码退款',
  REFUND_OTHER: '优惠码其它',
  CHARGE_OFFLINE_BONUS: '虚拟充值',
  REFUND_ORDER_CANCELLED: '订单取消退款',
  REFUND_ORDER_POSTSALE: '订单返款',
  REFUND_CHARGE: '充值退款',
  CASHOUT_SETTLEMENT: '体现结算',
  TRADE_ORDER: '订单支付',
  TRADE_OFFLINE_TRANSFER_OUT: '余额转出|提现',
  REFUND_ORDER: '订单退款'
}

// 提现状态
let cashoutTradeStatus = {
  // CANCELLED: '取消',
  // APPLY: '已申请|未审核',
  // AUDITED: '已审核|待退款',
  // DONE_CASHOUT: '已提现',
  // INVOICED: '已开票',
  // REJECTED: '审核拒绝'
  // CANCELLED: '取消',
  APPLY: '申请提现',
  AUDITED: '财务已审核',
  INVOICED: '已收发票',
  DONE_CASHOUT: '已提现',
  REJECTED: '已拒绝'
}

// 审核状态
const tradeStatus = {
  AUDITED: '已审核',
  APPLY: '未审核',
  REJECTED: '已拒绝',
  APPLY_REFUND: '申请退款',
  REFUNDED: '已退款',
  PARTIAL_REFUNDED: '已部分退款'
}

const vpayTradeMethod = {
  // CHARGE_OFFLINE_TRANSFER_IN: '余额转入',
  // TRADE_ORDER_POSTSALE: '售后扣款',
  // // CHARGE_OTHER: '其它',
  // CHARGE_OFFLINE: '线下充值',
  // CHARGE_QRCODE: '线上充值',
  // TRADE_ORDER_FEE: '扣运费',
  // TRADE_PROMO: '优惠码支付',
  // REFUND_PROMO: '优惠码退款',
  // // REFUND_OTHER: '其它',
  // CHARGE_OFFLINE_BONUS: '虚拟充值',
  // CHARGE_OFFLINE_SETTLE: '结算充入',
  // REFUND_ORDER_CANCELLED: '订单取消退款',
  // REFUND_ORDER_POSTSALE: '订单返款',
  // REFUND_CHARGE: '充值退款',
  // CASHOUT_SETTLEMENT: '体现结算',
  // TRADE_ORDER: '订单支付',
  // TRADE_OFFLINE_TRANSFER_OUT: '余额转出|提现',
  // REFUND_ORDER: '订单退款'
  CHARGE_QRCODE: '线上充值',
  CHARGE_OFFLINE_ACCT: '线下充值',
  CHARGE_OFFLINE_SETTLE: '结算',
  CHARGE_OFFLINE_BONUS: '积分',
  CHARGE_OTHER: '其他充值',

  CONSUME_VPAY_PROMO: '码余额支付',
  CONSUME_VPAY_ORDER: '订单余额支付',
  CONSUME_QRCODE_ORDER: '订单在线支付',

  REFUND_CASHOUT: '提现', // 结算余额提现
  REFUND_ONLINE: '线上退款',
  REFUND_OFFLINE: '线下退款',
  // REFUND_CLEAN_BONUS: '清空礼金券',
  DEDUCT_OTHER_VPAY: '其他扣款',
  MP_WXPAY_STORE: '订单在线支付'
}

// 充值类型
const vpayChargeType = {
  PAY_QRCODE: '扫码支付',
  VPAY: '余额支付',
  OFFLINE: '线下支付'
}

const vpayChargeExtTradeMethod = {
  CHARGE_OFFLINE_TRANSFER_IN: '余额转入',
  TRADE_OFFLINE_TRANSFER_OUT: '余额转出',
  CHARGE_OFFLINE_BONUS: '虚拟充值'
}

// 充值方式
const vpayChargeMethod = {
  CHARGE_QRCODE: '线上充值',
  CHARGE_OFFLINE_ACCT: '线下充值',
  CHARGE_OFFLINE_SETTLE: '结算',
  CHARGE_OFFLINE_BONUS: '积分',
  // CHARGE_OFFLINE_BONUS: '赠送充值',
  CHARGE_OTHER: '其他充值'
  // CHARGE_OFFLINE_TRANSFER_IN: '余额转入',
  // TRADE_OFFLINE_TRANSFER_OUT: '余额转出',

  // CHARGE_OTHER: '其它充值',
  // DEDUCT_CLEAN_BONUS: '清空礼金券',
  // REFUND_OFFLINE: '线下退款',
  // REFUND_ONLINE: '线上退款',
  // CHARGE_QRCODE: '线上充值',
  // CONSUME_VPAY_PROMO: '码-余额支付',
  // REFUND_CASHOUT: '结算余额提现',
  // CONSUME_QRCODE_ORDER: '订单-qrcode',
  // CHARGE_OFFLINE_BONUS: '虚拟充值',
  // CHARGE_OFFLINE_SETTLE: '结算充入',
  // CHARGE_OFFLINE_ACCT: '线下充值',
  // CONSUME_VPAY_ORDER: '订单-余额支付',
  // DEDUCT_OTHER_VPAY: '其它扣款'
}

// 余额明细充值方式
const vpayOrderChargeMethod = {
  CHARGE_QRCODE: '线上充值',
  CHARGE_OFFLINE_ACCT: '线下充值',
  CHARGE_OFFLINE_SETTLE: '充值结算',
  CHARGE_OFFLINE_BONUS: '积分',
  // CHARGE_OFFLINE_BONUS: '赠送充值',
  CHARGE_OTHER: '其他充值',
  // CHARGE_OFFLINE_TRANSFER_IN: '余额转入',
  // TRADE_OFFLINE_TRANSFER_OUT: '余额转出',

  // CHARGE_OTHER: '其它充值',
  DEDUCT_CLEAN_BONUS: '清空礼金券',
  // REFUND_OFFLINE: '线下退款',
  // REFUND_ONLINE: '线上退款',
  // CHARGE_QRCODE: '线上充值',
  // CONSUME_VPAY_PROMO: '码-余额支付',
  // REFUND_CASHOUT: '结算余额提现',
  // CONSUME_QRCODE_ORDER: '订单-qrcode',
  // CHARGE_OFFLINE_BONUS: '虚拟充值',
  // CHARGE_OFFLINE_SETTLE: '结算充入',
  // CHARGE_OFFLINE_ACCT: '线下充值',
  // CONSUME_VPAY_ORDER: '订单-余额支付',
  DEDUCT_OTHER_VPAY: '其它扣款'
}

const auditStatus = {
  APPLY: '未审核',
  AUDITED: '已审核',
  // REJECTED: '审核拒绝',
  REJECTED: '已拒绝',
  CANCELLED: '已取消',
  APPLY_REFUND: '申请退款',
  REFUNDED: '已退款',
  PARTIAL_REFUNDED: '已部分退款'
  // Nil: ''
}

const crmAuditStatus = {
  PENDING: '待审核',
  HANDLE: '已审核',
  REFUSE: '已拒绝'
}

const pmsAuditStatus = {
  WAIT_AUDIT: '等待审核',
  AUDIT_SUCCESS: '设计审核成功',
  AUDIT_FAIL: '审核失败'
}

const cashoutStatus = {
  APPLIED: '申请提现',
  AUDITED: '财务已审核',
  INVOICED: '已开发票',
  CASHSED_OUT: '已提现'
}

const refundStatus = {
  APPLY: '申请退款',
  REFUNDED: '已退款',
  REJECTED: '审核拒绝'
}

// 退款类型
let refundType = {
  REFUND_OFFLINE: '线下退款',
  REFUND_ONLINE: '线上退款'
}
let storeType = {
  WXBIZ: '微商',
  STUDIO: '影楼',
  FULFILLER: '后期',
  CONSUMABLES: '耗材',
  OFFLINE: '线下',
  CHANNECUSTOMIZATION: '渠道产品定制'
}
let promoStatusList = {
  APPLY: '已申请',
  PARTIAL_REFUNED: '部分退款完成',
  PRODUCED: '已生成',
  PRODUCE_FAILED: '生成失败',
  PRODUCIING: '生成中',
  REFUNDED: '退款完成',
  OTHER: '其他'
}

let settlementStatus = {
  UNSETTLED: '待结算',
  IN_PROGRESS: '结算中',
  SETTLED: '已结算',
  CANCELLED: '拒绝结算'
}

let FapiaoStatus = {
  INVOICING: '开票中',
  // APPLY: '申请',
  APPLY: '未开票',
  INVOICED: '已开票',
  INVOICE_FAILED: '开票失败'
}

let FapiaoTitleType = {
  ENTERPRISE: '企业',
  INDIVIDUAL: '个人'
}

let FapiaoType = {
  // VAT_SPECIAL: '增值税专用发票',
  // ELECTRONIC: '电子增值税普通发票'
  VAT_SPECIAL: '增值税发票',
  ELECTRONIC: '普通电子发票'

}

let accountType = {
  ACCT: '充值余额',
  BONUS: '礼金券',
  SETTLE: '结算余额'
}

// let tradeStatus = {
//     APPLY: '待审核',
//     AUDITED: '已审核',
//     REJECTED: '审核拒绝'
//     // CANCELLED: '已取消'
// }

let channel = {
  B2B: '本店订单',
  B2C: '拓客订单'
  // OPEN,OTHER,SAAS
}

let refundTradeStatus = {
  CANCELLED: '取消',
  REFUNDED: '已退款',
  APPLY: '已申请|未审核',
  AUDITED: '已审核|待退款',
  REJECTED: '审核拒绝'
}

// 退款状态
let refundsTradeStatus = {
  APPLY: '申请退款',
  AUDITED: '待退款',
  REFUNDED: '已退款',
  REJECTED: '审核拒绝'
}

// 扣款状态
let deductTradeStatus = {
  // CANCELLED: '取消',
  // APPLY: '未审核',
  // AUDITED: '已审核',
  // REJECTED: '审核拒绝'
  AUDITED: '已审核',
  APPLY: '待审核',
  REJECTED: '已拒绝'
}
// 产品类型
let productType = {
  CUSTOM: '定制',
  DIY: 'DIY定制',
  NORMAL: '通货',
  SALE_SAMPLE: '业务样品'
}
const config = {
  productType,
  channel,
  tradeStatus,
  accountType,
  FapiaoStatus,
  FapiaoTitleType,
  FapiaoType,
  pageType,
  barcodePosition,
  leftComposeCode,
  spuType,
  orderStatus,
  originTypes,
  orderItemStatus,
  orderType,
  paymentType,
  paymentTypeB,
  paymentTypeCz,
  paymentStatus,
  tradeType,
  tradeMethod,
  vpayTradeMethod,
  vpayChargeType,
  vpayChargeMethod,
  vpayChargeExtTradeMethod,
  auditStatus,
  storeType,
  crmAuditStatus,
  pmsAuditStatus,
  cashoutStatus,
  refundStatus,
  promoStatusList,
  settlementStatus,
  templateType,
  refundTradeStatus,
  cashoutTradeStatus,
  vpayOrderChargeMethod,
  deductTradeStatus,
  refundsTradeStatus,
  refundType,
  paymentTypes,
  payType
}
export const initApp = (app) => {
  app.prototype.$config = config
}
export default config
